import { Button, VStack } from "@chakra-ui/react";
import { MdMenuBook, MdPlayCircle } from "react-icons/md";
import { APP_NAME } from "utils/config";
import {
  ONBOARDING_RESOURCES_URL,
  ONBOARDING_WALKTHROUGH_VIDEO_URL,
} from "utils/links";
import ResourceLink from "./ResourceLink";

type Props = {
  onDismiss: () => void;
};

export default function WidgetResources({ onDismiss }: Props) {
  return (
    <VStack
      position="relative"
      zIndex={1}
      alignItems="stretch"
      spacing={1}
      borderTopWidth="1px"
      borderColor="gray.100"
      background="gray.50"
      p={3}
    >
      <ResourceLink
        href={ONBOARDING_WALKTHROUGH_VIDEO_URL}
        IconComponent={MdPlayCircle}
        title="Watch the walkthrough"
        description={`See how ${APP_NAME} works end-to-end`}
      />
      <ResourceLink
        href={ONBOARDING_RESOURCES_URL}
        IconComponent={MdMenuBook}
        title="Visit the Resources Hub"
        description="Guides, templates, and best practices"
      />
      <Button
        variant="link"
        size="sm"
        alignSelf="flex-start"
        color="gray.600"
        _hover={{ color: "lightPink" }}
        fontSize="xs"
        fontWeight={500}
        mt={2}
        onClick={onDismiss}
      >
        Don’t show me this again
      </Button>
    </VStack>
  );
}
